var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#checked_svg__clip0_936:1046)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 18.75,
    height: 18.75,
    rx: 9.375,
    fill: "url(#checked_svg__paint0_linear_936:1046)",
    stroke: "url(#checked_svg__paint1_linear_936:1046)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5l3 3L14 7",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "checked_svg__paint0_linear_936:1046",
    x1: 1.351,
    y1: 7.75,
    x2: 18.919,
    y2: 7.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A5C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "checked_svg__paint1_linear_936:1046",
    x1: 1.351,
    y1: 7.75,
    x2: 18.919,
    y2: 7.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A5C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "checked_svg__clip0_936:1046"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var MemoSvgChecked = /*#__PURE__*/React.memo(SvgChecked);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzkzNjoxMDQ2KSI+CjxyZWN0IHg9IjAuNjI1IiB5PSIwLjYyNSIgd2lkdGg9IjE4Ljc1IiBoZWlnaHQ9IjE4Ljc1IiByeD0iOS4zNzUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl85MzY6MTA0NikiIHN0cm9rZT0idXJsKCNwYWludDFfbGluZWFyXzkzNjoxMDQ2KSIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTYgMTAuNUw5IDEzLjVMMTQgNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfOTM2OjEwNDYiIHgxPSIxLjM1MTM1IiB5MT0iNy43NSIgeDI9IjE4LjkxODkiIHkyPSI3Ljc1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMxQ0IwQUIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMzNBNUM5Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl85MzY6MTA0NiIgeDE9IjEuMzUxMzUiIHkxPSI3Ljc1IiB4Mj0iMTguOTE4OSIgeTI9IjcuNzUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzFDQjBBQiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzM0E1QzkiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MzY6MTA0NiI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { MemoSvgChecked as ReactComponent };